import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Translate } from 'react-jhipster';
import { Button } from 'reactstrap';
import { IQuotation } from 'app/shared/model/quotation.model';

interface ApprovalDialogProps {
  open: boolean;
  onClose: () => void;
  poId: string;
  onClick: () => void;
  quotationEntity: IQuotation;
  onClick1: () => void;
}

const ApprovalDialog: React.FC<ApprovalDialogProps> = ({ open, onClose, poId, onClick, quotationEntity, onClick1 }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle></DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'black' }} className="mb-3">
          <Translate contentKey="comexApp.quotation.keepModal.requestKeepLabel" interpolate={{ poId }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions className="mx-3 mb-3">
        <Button variant="contained" id="save-entity" data-cy="entityCreateSaveButton" onClick={onClose}>
          <Translate contentKey="comexApp.quotation.cancelBtnLabel">Cancel</Translate>
        </Button>
        &nbsp;
        <Button
          variant="contained"
          color="error" // Changed from "danger" to "error" as Material-UI v5 uses "error"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          type="submit"
          onClick={onClick}
          disabled={quotationEntity?.comexAdminDecision !== null}
        >
          <Translate contentKey="comexApp.quotation.DenyBtnLabel">Deny</Translate>
        </Button>
        &nbsp;
        <Button
          variant="contained"
          color="primary"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          type="submit"
          onClick={onClick1}
          disabled={quotationEntity?.comexAdminDecision !== null}
        >
          <Translate contentKey="comexApp.quotation.ApproveBtnLabel">Approve</Translate>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalDialog;
